module.exports = __webpack_public_path__ + "static/img/08.3a6c501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/08.png
// module id = QHgb
// module chunks = 1